import auditEventService from 'Services/AuditEventService'

export default {
  install: function (Vue) {
    const saveAuditEvent = (context, event, data = {}) => {
      return auditEventService.post({
        event,
        dateTimeUtc: new Date(),
        ...['business', 'merchant'].reduce((result, segment) => context.isSelected(segment) ? Object.assign({}, result, { [`${segment}Id`]: context[segment].id }) : result, {}),
        metaData: {
          ...Object.keys(data).reduce((result, key) => { return { ...result, [key.toLocaleLowerCase()]: data[key].toLowerCase() } }, {})
        }
      })
    }

    Object.defineProperties(Vue.prototype, {
      '$trackAuditEvent': {
        get () {
          return saveAuditEvent
        }
      }
    })
  }
}
